import { render, staticRenderFns } from "./AnagraficaAziendale_Tab1.vue?vue&type=template&id=0b9068a0&scoped=true&"
import script from "./AnagraficaAziendale_Tab1.vue?vue&type=script&lang=js&"
export * from "./AnagraficaAziendale_Tab1.vue?vue&type=script&lang=js&"
import style0 from "./AnagraficaAziendale_Tab1.vue?vue&type=style&index=0&id=0b9068a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9068a0",
  null
  
)

export default component.exports